// Gallery slider
var productSlider = null;
var isMobileSliderActive = false;

function initProductSlider() {
  if (productSlider) return; // Prevent double init
  productSlider = new Swiper(".productSlider", {
    slidesPerView: 2.2,
    spaceBetween: 10,
    autoHeight: false,
    loop: true,
    simulateTouch: false, // disable Swiper's touch handling
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    on: {
      // Gallery videos play only while on screen (see the video block below).
      slideChangeTransitionEnd: function () {
        if (window.iwdSyncGalleryVideos) window.iwdSyncGalleryVideos();
      }
    },
    // Responsive breakpoints
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      768: {
        spaceBetween: 20,
        slidesPerView: 1.9
      },
      1280: {
        spaceBetween: 10,
        slidesPerView: 2.122
      }
    }
  });
  isMobileSliderActive = true;
}

function destroyProductSlider() {
  if (productSlider && typeof productSlider.destroy === 'function') {
    productSlider.destroy(true, true);
    productSlider = null;
    isMobileSliderActive = false;
  }
}

function handleProductSlider() {
  if (window.innerWidth < 767) {
    if (!isMobileSliderActive) {
      initProductSlider();
    }
  } else {
    if (isMobileSliderActive) {
      destroyProductSlider();
    }
  }
}

window.addEventListener('DOMContentLoaded', handleProductSlider);
window.addEventListener('resize', handleProductSlider);




// Related products row. The recommendations are fetched into <product-recommendations> when it nears the viewport,
// so watch only that element (not the whole body) until `.relatedSlider` appears, then init once and stop.
(function () {
  function initRelatedSlider(sliderEl) {
    console.log('[Swiper Init]: Element found, initializing...');

    // Initialize Swiper. The arrows are the row's own (siblings of the slider): a page-wide
    // '.swiper-button-next' also took over the buy-box Shop the look arrows.
    new Swiper('.relatedSlider', {
      slidesPerView: 4,
      spaceBetween: 16,
      autoHeight: false,
      loop: false,
      navigation: {
        nextEl: sliderEl.parentElement.querySelector('.swiper-button-next'),
        prevEl: sliderEl.parentElement.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        320: {
          slidesPerView: 1.3,
          spaceBetween: 12,
        },
        560: {
          slidesPerView: 2.3,
          spaceBetween: 14,
        },
        768: {
          spaceBetween: 16,
          slidesPerView: 2.8,
        },
        1280: {
          spaceBetween: 16,
          slidesPerView: 4,
        },
      },
    });
  }

  // Server-rendered row (cross-sell branch): it is already in the DOM.
  var existing = document.querySelector('.relatedSlider');
  if (existing) {
    initRelatedSlider(existing);
    return;
  }

  // No recommendations element on this page: nothing to wait for.
  var hosts = document.querySelectorAll('product-recommendations');
  if (!hosts.length) return;

  var observer = new MutationObserver(function (mutations, observer) {
    var sliderEl = document.querySelector('.relatedSlider');
    if (sliderEl) {
      // Done - stop watching
      observer.disconnect();
      initRelatedSlider(sliderEl);
    }
  });
  hosts.forEach(function (host) {
    observer.observe(host, { childList: true, subtree: true });
  });
})();


$(document).ready(function(){
  // Handle click event on accordion heading
  $('.shogun-accordion-heading').click(function(){
      // Toggle the plus/minus icon
      $(this).find('.shogun-accordion-icon').toggleClass('shogun-icon-plus shogun-icon-minus');
      // Toggle visibility of accordion body
      $(this).next('.shogun-accordion-body').slideToggle();
  });
});

// --- Custom script to update review badge text ---
document.addEventListener('DOMContentLoaded', function() {
  function updateJdgmPrevBadgeText() {
    document.querySelectorAll('.jdgm-prev-badge__text').forEach(function(el) {
      // Match text like '15 reviews', '1 review', etc.
      var match = el.textContent.trim().match(/^(\d+)\s+reviews?$/i);
      if (match) {
        el.textContent = `(${match[1]})`;
      }
    });
  }

  // Run on page load
  updateJdgmPrevBadgeText();

  // Judge.me may re-render its badges: watch only the badge widgets (not the whole body, where apps
  // insert many nodes) and reformat at most once per frame.
  var badgeWidgets = document.querySelectorAll('.jdgm-preview-badge');
  if (!badgeWidgets.length) return;
  var badgeQueued = false;
  var badgeObserver = new MutationObserver(function () {
    if (badgeQueued) return;
    badgeQueued = true;
    requestAnimationFrame(function () {
      badgeQueued = false;
      updateJdgmPrevBadgeText();
    });
  });
  badgeWidgets.forEach(function (widget) {
    badgeObserver.observe(widget, { childList: true, subtree: true });
  });
});




// --- Move .price-review_wrapper to mobile content for < 767px screens ---
(function() {
  var originalParent = null;
  var originalNextSibling = null;
  var moved = false;

  function movePriceReviewWrapper() {
    var priceReview = document.querySelector('.price-review_wrapper');
    var infoWrapper = document.querySelector('.mobile-content');
    if (!priceReview || !infoWrapper) return;

    if (window.innerWidth < 767) {
      if (!moved) {
        // Store original position
        originalParent = priceReview.parentNode;
        originalNextSibling = priceReview.nextSibling;
        // Move to end of info wrapper
        infoWrapper.appendChild(priceReview);
        moved = true;
      }
    } else {
      // Move back to original position if needed
      if (moved && originalParent) {
        if (originalNextSibling) {
          originalParent.insertBefore(priceReview, originalNextSibling);
        } else {
          originalParent.appendChild(priceReview);
        }
        moved = false;
      }
    }
  }

  window.addEventListener('DOMContentLoaded', movePriceReviewWrapper);
  window.addEventListener('resize', movePriceReviewWrapper);
})();



// --- Gallery videos: download nothing until the video is on screen ---
// Videos carry preload="none" and no autoplay (snippets/product-thumbnail.liquid). Play while at least 25% is
// visible, pause otherwise. On tablet/desktop the poster is set when the video nears the viewport; on phones the
// slide's own preview image sits under the video, so no poster is needed there.
(function () {
  var videos = [];
  var wideMQ = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;

  function setPoster(video) {
    var poster = video.getAttribute('data-iwd-poster');
    if (!poster || video.getAttribute('poster')) return true;
    if (wideMQ && !wideMQ.matches) return false;
    video.setAttribute('poster', poster);
    return true;
  }
  function play(video) {
    if (!video.paused) return;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }
  function pause(video) {
    if (!video.paused) video.pause();
  }
  function visibleShare(el) {
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return 0;
    var left = Math.max(r.left, 0), right = Math.min(r.right, window.innerWidth);
    var top = Math.max(r.top, 0), bottom = Math.min(r.bottom, window.innerHeight);
    var clip = el.closest('.swiper');
    if (clip) {
      var c = clip.getBoundingClientRect();
      left = Math.max(left, c.left); right = Math.min(right, c.right);
      top = Math.max(top, c.top); bottom = Math.min(bottom, c.bottom);
    }
    if (right <= left || bottom <= top) return 0;
    return ((right - left) * (bottom - top)) / (r.width * r.height);
  }

  // Also called by the gallery Swiper after each slide change.
  window.iwdSyncGalleryVideos = function () {
    videos.forEach(function (video) {
      if (visibleShare(video) >= 0.25) play(video);
      else pause(video);
    });
  };

  function init() {
    videos = Array.prototype.slice.call(document.querySelectorAll('video[data-iwd-autoplay]'));
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) { setPoster(video); play(video); });
      return;
    }
    var playObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.25) play(entry.target);
        else pause(entry.target);
      });
    }, { threshold: [0, 0.25] });
    var nearObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && setPoster(entry.target)) nearObserver.unobserve(entry.target);
      });
    }, { rootMargin: '600px 0px' });
    videos.forEach(function (video) {
      playObserver.observe(video);
      nearObserver.observe(video);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
